/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getSubscriptionEntitlement from '../../utils/getSubscriptionEntitlement';
import { premiumPerksPropType } from '../../propTypes/promotions';
import { SL_WEB_PREMIUM_PERKS_AD } from '../../common/treatments';
import config from '../../config';

const getClassName = isPremium =>
  classNames({
    'sl-premium-benefits-center': true,
    'sl-premium-benefits-center--premium': isPremium,
  });

const PremiumBenefitsCenter = ({
  userDetails,
  isPremium,
  doTrackEvent,
  premiumPerks,
  doLoadTreatment,
  spotName,
  spotId,
}) => {
  const randomIndex = Math.round(Math.random() * (premiumPerks.perks.length - 1));
  const perk = premiumPerks.perks[randomIndex];
  const treatment = doLoadTreatment(SL_WEB_PREMIUM_PERKS_AD);
  const text =
    treatment === 'variation_a'
      ? 'Save big on boards, travel and gear.'
      : 'Exclusive Deals on Top Brands.';
  const linkText = treatment === 'variation_a' ? 'Save Now' : 'View Deals';
  const subscriptionEntitlement = getSubscriptionEntitlement(isPremium, userDetails);
  return (
    <div
      className={getClassName(isPremium)}
      onClick={() => {
        doTrackEvent('Clicked Link', {
          category: 'premium perks',
          linkLocation: 'Spot report page premium perks unit',
          linkURL: `${config.surflineHost}/premium-perks`,
          pageName: 'Spot Report',
          spotId,
          spotName,
          subscriptionEntitlement,
          perk: perk.name,
          perkId: perk._id,
        });
        window.location.assign('/premium-perks');
      }}
    >
      <div className="sl-premium-benefits-center__text">
        <h3>Premium Perks</h3>
        <p>
          {text}
          <a href="/premium-perks">{linkText}</a>
        </p>
      </div>
      <div className="sl-premium-benefits-center__image-containers">
        <div className="sl-premium-benefits-center__image-containers__perk">
          <img alt={perk.name} src={perk.bgDesktopImgPath} />
          {isPremium && perk.discountText && (
            <div className="sl-premium-benefits-center__image-containers__perk__discount">
              {perk.discountText}
            </div>
          )}
        </div>
        <div className="sl-premium-benefits-center__image-containers__logo">
          <img alt={`${perk.name} logo`} src={perk.logoImgPath} />
        </div>
      </div>
    </div>
  );
};

PremiumBenefitsCenter.propTypes = {
  userDetails: PropTypes.arrayOf(PropTypes.string),
  isPremium: PropTypes.bool,
  doTrackEvent: PropTypes.func.isRequired,
  premiumPerks: premiumPerksPropType.isRequired,
  doLoadTreatment: PropTypes.func.isRequired,
  spotName: PropTypes.string,
  spotId: PropTypes.string,
};

PremiumBenefitsCenter.defaultProps = {
  userDetails: [],
  isPremium: false,
  spotName: null,
  spotId: null,
};

export default PremiumBenefitsCenter;
